import 'css-chunksrc/client/scenes/projectGroupCreation/groupCreationForm/styles.scss';export default {
  "groupCreationForm": "_groupCreationForm_pn5mw_1",
  "group": "_group_pn5mw_1",
  "groupOverflow": "_groupOverflow_pn5mw_12",
  "title": "_title_pn5mw_16",
  "input": "_input_pn5mw_28",
  "textArea": "_textArea_pn5mw_42"
};